import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxGalleryAnimation } from 'ngx-gallery';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { firebase } from '@firebase/app';
import { ContentsMandatory } from '../../core/models/contents-mandatory';
import { NewPageList } from '../../core/models/new-page-list';
import { NewPagePref } from '../../core/models/new-page-prefs';
import { DragulaService } from 'ng2-dragula/ng2-dragula';
import { Constants } from '../../core/config/Constants';
@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css'],
  viewProviders: [DragulaService]
})
export class SliderComponent implements OnInit {
  aboutUs: NewPageList;
  eventId: string;
  eventSlider: boolean = true;
  currentFiles = [];
  uploadFileName: string = null;
  uploadprogress: number = null;
  images: string[] = new Array();
  cmCategory: string;


  tagName = 'dragId';

  @ViewChild("FileUpload") fileUploader;

  constructor(private dragula: DragulaService, private newPageService: NewPageService, private confirmationService: ConfirmationService) {
    const bag: any = this.dragula.find(this.tagName);
    if (bag !== undefined) this.dragula.destroy(this.tagName);
    this.dragula.setOptions(this.tagName, {});
  }
  ngOnInit() {

    this.aboutUs.aboutPrefs = new NewPagePref();
    if (this.aboutUs.contentMandatoryList) {
      for (let i = 0; i < this.aboutUs.contentMandatoryList.length; i++) {
        if (this.aboutUs.contentMandatoryList[i]) {
          this.newPageService.getContentsMandatory(this.aboutUs.contentMandatoryList[i], this.eventId).subscribe((conMan) => {
            console.log(conMan);
            this.newPageService.getFile(conMan, this.eventId).then((url) => {
              this.images[i] = url;
            });
          })
        }
      }
    } else {
      this.aboutUs.contentMandatoryList = new Array();
    }
    this.dragula.drop.subscribe(value => {
      this.onDrop(value.slice(1));
    });
  }
  private onDrop(args) {
    let [e] = args;
    let sourceIndex = +e.getAttribute('item-index');
    let targetIndex = this.getElementIndex(e);
    this.swapData(sourceIndex, targetIndex);
    console.log(this.aboutUs.contentMandatoryList);
    //console.log(sourceIndex,targetIndex);
  }
  swapData(index: number, index2: number) {
    let temp = this.aboutUs.contentMandatoryList[index];
    if (index2 > index) {
      for (let i = index; i < index2; i++) {
        this.aboutUs.contentMandatoryList[i] = this.aboutUs.contentMandatoryList[i + 1];
      }
    } else {
      for (let i = index; i > index2; i--) {
        this.aboutUs.contentMandatoryList[i] = this.aboutUs.contentMandatoryList[i - 1];
      }
    }
    this.aboutUs.contentMandatoryList[index2] = temp;
  }
  private getElementIndex(el: any) {
    return [].slice.call(el.parentElement.children).indexOf(el);
  }
  _ref: any;
  onBasicUpload(event) {
    this.currentFiles = event.files;
    if (!this.aboutUs.contentMandatoryList) {
      this.aboutUs.contentMandatoryList = new Array();
    }
    console.log(event.files[0]);
    for (let i = 0; i < event.files.length; i++) {
      this.newPageService.uploadFile(this.eventId, event.files[i], this.cmCategory).on(firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
          this.uploadFileName = event.files[0].filename;
          this.uploadprogress = Math.floor((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        },
        (error) => {
        },
        () => {
          let contentsMandatory = new ContentsMandatory();
          if (this.cmCategory) {
            console.log(this.cmCategory);
            contentsMandatory.category = this.cmCategory;
          } else {
            console.log(this.cmCategory);
            contentsMandatory.category = Constants.CONTENT_M_TYPE_ABOUT;
          }
          contentsMandatory.eventId = this.eventId;
          contentsMandatory.filename = event.files[i].name;
          contentsMandatory.sizeInBytes = event.files[i].size;
          contentsMandatory.extension = event.files[i].type.split('/').pop();
          console.log(contentsMandatory);
          let key = this.newPageService.addContentMandatory(contentsMandatory);
          this.aboutUs.contentMandatoryList.push(key);
          this.newPageService.getFile(contentsMandatory, this.eventId).then((url) => {
            this.images.push(url);
          });
        }
      );
    }
    setTimeout(() => {
      this.fileUploader.files = new Array()
    }, 5000);
  }
  deleteImage(event) {
    //let index  = this.currentFiles.length - this.currentFiles.indexOf(event.file);
    console.log('currentFiles', this.currentFiles.length);
    console.log('contentMandatoryList', this.aboutUs.contentMandatoryList.length);
    this.uploadFileName = null;
    this.uploadprogress = null;
    //this.galleryImages = this.galleryImages.filter((val, i) => i != index);
    //this.aboutUs.contentMandatoryList = this.aboutUs.contentMandatoryList.filter((val, i) => i != index);
  }

  deleteSliderImage(index) {
    this.images = this.images.filter((val, i) => i != index);
    this.aboutUs.contentMandatoryList = this.aboutUs.contentMandatoryList.filter((val, i) => i != index);
  }

  confirmDelete() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete ?',
      accept: () => {
        this.remove();
      }
    });
  }

  remove() {
    this._ref.destroy();
    this.newPageService.removeItem(this.aboutUs);
  }

  upItem() {
    this.newPageService.upItem(this.aboutUs);
  }

  downItem() {
    this.newPageService.downItem(this.aboutUs);
  }


  /*(function($) {
      $(document).ready(function() {
              $("#owl-example").owlCarousel();
      });
  }) (jQuery);
  */

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/layout/slider/slider.component.ts